export const TABLE_KEYS = {
  assessmentsTable: 'surveysTable',
  assessmentsDSTable: 'surveysDSTable',
  programsTable: 'programsTable',
  programsDSTable: 'programsDSTable',
  patientsTable: 'patientsTable',
  patientsPopulationHealthTable: 'patientsPopulationHealthTable',
  patientsDSTable: 'patientsDSTable',
  resourcesTable: 'resourcesTable',
  resourcesDSTable: 'resourcesDSTable',
  claimsTable: 'claimsTable',
  claimsDSTable: 'claimsDSTable',
  ordersTable: 'ordersTable',
  ordersDSTable: 'ordersDSTable',
  accountsTable: 'accountsTable',
  alertsTable: 'alertsTable',
  alertsDSTable: 'alertsDSTable',
  usersTable: 'usersTable',
  usersDSTable: 'usersDSTable',
  usersManagingTable: 'usersListTable',
  claimReportsTable: 'claimReportsTable',
  claimReportsDSTable: 'claimReportsDSTable',
  reportableTable: 'reportablesTable',
  reportableDSTable: 'reportablesDSTable',
  allowedAccountsTable: 'allowedAccountsTable',
  dashboardAssessmentsAlertsTable: 'dashboardAssessmentsAlertsTable',
  cptsTable: 'cptsTable',
  botActivitiesTable: 'botActivitiesTable',
  botActivitiesDSTable: 'botActivitiesDSTable',
  providersTable: 'providersTable',
  claimsManagerPortfolioTable: 'claimsManagerPortfolioTable',
  claimsManagerCptMixTable: 'claimsManagerCptMixTable',
  claimsManagerSupportingClaimsTable: 'claimsManagerSupportingClaimsTable',
  // Reimbursement by insurance payer: account mode (one CPT, one row
  // per payer) and portfolio mode (one row per payer AND account).
  // Same key for both; the preference row the backend registers is
  // `claimsManagerCptInsurancesTable`.
  claimsManagerCptInsurancesTable: 'claimsManagerCptInsurancesTable',
  bhiDashboardPortfolioTable: 'bhiDashboardPortfolioTable',
  bhiDashboardAccountDetailTable: 'bhiDashboardAccountDetailTable',
  bhiDashboardPatientsTable: 'bhiDashboardPatientsTable',
  // Patient picker inside the Start a Program dialog. Its own key so its
  // filters and sort never bleed into the Patients page (and vice versa).
  startJourneyPatientsTable: 'startJourneyPatientsTable',
  journeysTable: 'journeysTable',
  // Patient Dashboard "Programs" tab. Its own key so its session filters
  // and sort never bleed into the Journeys page (same reason
  // startJourneyPatientsTable is separate from patientsTable).
  patientJourneysTable: 'patientJourneysTable',
  journeysDSTable: 'journeysDSTable',
  journeyProgramsTable: 'journeyProgramsTable',
};

export const TABLE_NAMES = {
  [TABLE_KEYS.programsTable]: 'programs',
  [TABLE_KEYS.programsDSTable]: 'programs',
  [TABLE_KEYS.assessmentsTable]: 'surveys',
  [TABLE_KEYS.assessmentsDSTable]: 'surveys',
  [TABLE_KEYS.patientsTable]: 'patients',
  [TABLE_KEYS.patientsDSTable]: 'patients',
  [TABLE_KEYS.resourcesTable]: 'resources',
  [TABLE_KEYS.resourcesDSTable]: 'resources',
  [TABLE_KEYS.ordersTable]: 'orders',
  [TABLE_KEYS.ordersDSTable]: 'orders',
  [TABLE_KEYS.claimsTable]: 'claims',
  [TABLE_KEYS.claimsDSTable]: 'claims',
  [TABLE_KEYS.claimReportsTable]: 'claimReports',
  [TABLE_KEYS.claimReportsDSTable]: 'claimReports',
  [TABLE_KEYS.reportableTable]: 'reportables',
  [TABLE_KEYS.reportableDSTable]: 'reportables',
  [TABLE_KEYS.accountsTable]: 'accounts',
  [TABLE_KEYS.allowedAccountsTable]: 'allowedAccounts',
  [TABLE_KEYS.alertsTable]: 'alerts',
  [TABLE_KEYS.alertsDSTable]: 'alerts',
  [TABLE_KEYS.usersTable]: 'users',
  [TABLE_KEYS.usersManagingTable]: 'usersManaging',
  [TABLE_KEYS.dashboardAssessmentsAlertsTable]: 'dashboardAssessmentsAlerts',
  [TABLE_KEYS.cptsTable]: 'cpts',
  [TABLE_KEYS.botActivitiesTable]: 'botActivities',
  [TABLE_KEYS.botActivitiesDSTable]: 'botActivities',
  [TABLE_KEYS.patientsPopulationHealthTable]: 'patientsPopulationHealthTable',
  [TABLE_KEYS.providersTable]: 'providers',
  [TABLE_KEYS.claimsManagerPortfolioTable]: 'claimsManagerPortfolio',
  // The lookup endpoint that serves the CPT-code typeahead on this
  // table is `/lookups/claimsManagerCpts` — same name so the shared
  // SelectWithDynamicHintFilter builds the URL correctly. Preferences
  // and other tableKey-scoped machinery key off TABLE_KEYS, not this
  // name, so they stay stable.
  [TABLE_KEYS.claimsManagerCptMixTable]: 'claimsManagerCpts',
  [TABLE_KEYS.claimsManagerSupportingClaimsTable]: 'claimsManagerSupportingClaims',
  // No `/lookups/` table behind this one — its `q` filters run in
  // memory on the backend and the payer option list comes from the
  // response's `groupTotals`. The name is still needed for the
  // tableKey-scoped machinery (preferences, session filters).
  [TABLE_KEYS.claimsManagerCptInsurancesTable]: 'claimsManagerCptInsurances',
  [TABLE_KEYS.bhiDashboardPortfolioTable]: 'bhiPortfolio',
  [TABLE_KEYS.bhiDashboardPatientsTable]: 'bhiDashboardPatients',
  // Same lookups as the Patients page (the Account dynamic-hint filter
  // resolves `/lookups/patients`).
  [TABLE_KEYS.startJourneyPatientsTable]: 'patients',
  [TABLE_KEYS.journeysTable]: 'programJourneys',
  [TABLE_KEYS.journeysDSTable]: 'programJourneys',
  [TABLE_KEYS.patientJourneysTable]: 'programJourneys',
  [TABLE_KEYS.journeyProgramsTable]: 'programDefinitions',
};

export const DEFAULT_TABLES_SORTING = {
  [TABLE_KEYS.assessmentsTable]: { id: 'orderDate', desc: true },
  [TABLE_KEYS.assessmentsDSTable]: { id: 'orderDate', desc: true },
  [TABLE_KEYS.programsTable]: { id: 'createdTimestamp', desc: true },
  [TABLE_KEYS.programsDSTable]: { id: 'createdTimestamp', desc: true },
  [TABLE_KEYS.patientsTable]: { id: 'lastName', desc: false },
  [TABLE_KEYS.patientsDSTable]: { id: 'lastName', desc: false },
  [TABLE_KEYS.startJourneyPatientsTable]: { id: 'lastName', desc: false },
  // Matches the list endpoint's own default (newest first).
  [TABLE_KEYS.journeysTable]: { id: 'startedAt', desc: true },
  [TABLE_KEYS.journeysDSTable]: { id: 'startedAt', desc: true },
  [TABLE_KEYS.patientJourneysTable]: { id: 'startedAt', desc: true },
  [TABLE_KEYS.journeyProgramsTable]: { id: 'name', desc: false },
  [TABLE_KEYS.resourcesTable]: { id: 'orderTimestamp', desc: true },
  [TABLE_KEYS.resourcesDSTable]: { id: 'orderTimestamp', desc: true },
  [TABLE_KEYS.claimsTable]: { id: 'claimGeneratedTimestamp', desc: true },
  [TABLE_KEYS.claimsDSTable]: { id: 'claimGeneratedTimestamp', desc: true },
  [TABLE_KEYS.ordersTable]: { id: 'orderDate', desc: true },
  [TABLE_KEYS.ordersDSTable]: { id: 'orderDate', desc: true },
  [TABLE_KEYS.accountsTable]: { id: 'businessName', desc: false },
  [TABLE_KEYS.alertsTable]: { id: 'createdTimestamp', desc: true },
  [TABLE_KEYS.alertsDSTable]: { id: 'createdTimestamp', desc: true },
  [TABLE_KEYS.usersTable]: { id: 'firstName', desc: false },
  [TABLE_KEYS.usersDSTable]: { id: 'firstName', desc: false },
  [TABLE_KEYS.usersManagingTable]: { id: 'firstName', desc: false },
  [TABLE_KEYS.claimReportsTable]: { id: 'claimReportGeneratedTimestamp', desc: true },
  [TABLE_KEYS.claimReportsDSTable]: { id: 'claimReportGeneratedTimestamp', desc: true },
  [TABLE_KEYS.reportableTable]: { id: 'reportableGeneratedTimestamp', desc: true },
  [TABLE_KEYS.reportableDSTable]: { id: 'reportableGeneratedTimestamp', desc: true },
  // Matches the endpoint's own default (`BotActivityQuery.DEFAULT_SORT`).
  [TABLE_KEYS.botActivitiesTable]: { id: 'uploadTimestamp', desc: true },
  [TABLE_KEYS.botActivitiesDSTable]: { id: 'uploadTimestamp', desc: true },
  [TABLE_KEYS.allowedAccountsTable]: { id: 'businessName', desc: false },
  [TABLE_KEYS.patientsPopulationHealthTable]: { id: 'patientLastName', desc: true },
  [TABLE_KEYS.providersTable]: { id: 'name', desc: false },
  [TABLE_KEYS.claimsManagerPortfolioTable]: { id: 'qhsInvoiceBasis', desc: true },
  [TABLE_KEYS.claimsManagerCptMixTable]: { id: 'cptCode', desc: false },
  [TABLE_KEYS.claimsManagerSupportingClaimsTable]: { id: 'claimGenerated', desc: true },
  // Matches the endpoint's own default.
  [TABLE_KEYS.claimsManagerCptInsurancesTable]: { id: 'totalPaid', desc: true },
  [TABLE_KEYS.bhiDashboardPortfolioTable]: { id: 'closingActivePatients', desc: true },
  [TABLE_KEYS.bhiDashboardPatientsTable]: { id: 'enrollmentDate', desc: true },
};
